import api from './api';

const listProgramMembers = ({ organizationId, programId, ...query }) =>
  api.get(`/api/organizations/${organizationId}/programs/${programId}/members/`, { params: query });

export default {
  listProgramMembers,
};
